import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

export const notification = {
  // Toast Notifications
  success: (message: string, duration = 3000) => {
    toast.success(message, {
      position: "top-right",
      autoClose: duration,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },

  error: (message: string, duration = 4000) => {
    toast.error(message, {
      position: "top-right",
      autoClose: duration,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },

  info: (message: string, duration = 3000) => {
    toast.info(message, {
      position: "top-right",
      autoClose: duration,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },

  warning: (message: string, duration = 3000) => {
    toast.warning(message, {
      position: "top-right",
      autoClose: duration,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  },

  // Confirm Dialog
  confirm: async (title: string, message: string, confirmText = "Yes, Delete", cancelText = "Cancel"): Promise<boolean> => {
    const result = await Swal.fire({
      title,
      html: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      backdrop: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    return result.isConfirmed;
  },

  // Alert Dialog
  alert: async (title: string, message: string, icon: 'success' | 'error' | 'info' | 'warning' = 'info') => {
    await Swal.fire({
      title,
      html: message,
      icon,
      confirmButtonColor: '#6366f1',
      backdrop: true,
    });
  },

  // Loading Toast (returns a toast ID that can be updated or dismissed)
  loading: (message: string) => {
    return toast.loading(message, {
      position: "top-right",
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
    });
  },

  // Update a loading toast
  updateLoading: (toastId: string | number, message: string, type: 'success' | 'error' | 'info' = 'success') => {
    toast.update(toastId, {
      render: message,
      type: type,
      isLoading: false,
      autoClose: 3000,
    });
  },
};
